var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 136,
    viewBox: "0 0 130 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7038_65057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7027 130.266C100.437 130.266 129.405 101.297 129.405 65.563C129.405 29.8287 100.437 0.860352 64.7027 0.860352C28.9684 0.860352 0 29.8287 0 65.563C0 101.297 28.9684 130.266 64.7027 130.266Z",
    fill: "#EEEFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7598 103.593C31.1478 96.7958 38.1172 94.903 38.1172 94.903L54.723 88.708H70.6406L87.2465 94.903C87.2465 94.903 94.2158 96.7958 98.6038 103.593H26.7598Z",
    fill: "#A5DEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4052 135.945H110.131C110.131 131.557 109.873 125.276 109.873 125.276C108.325 98.9471 89.2235 94.8171 89.2235 94.8171C74.2524 91.2034 82.4263 114.348 82.4263 114.348C81.9961 119.941 82.8565 127.427 84.4052 135.945Z",
    fill: "#DCDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5652 73.1348H51.7969V94.3868H73.5652V73.1348Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6512 83.0295V73.1348H51.7969V78.0391C58.0779 83.2015 65.5634 83.8899 73.6512 83.0295Z",
    fill: "#CBCBB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8811 135.945C97.3113 124.501 97.1392 121.318 97.0532 117.446C96.7951 108.756 94.9882 101.356 89.2235 94.9031L73.6501 89.8267C73.6501 89.8267 76.9196 95.5914 62.6369 95.5914C62.6369 95.5914 53.2584 95.2472 51.8818 89.8267L36.0503 94.9031C36.0503 94.9031 22.5419 98.2587 20.2188 112.455L28.1345 127.082L27.8764 135.945H96.8811Z",
    fill: "#B2B7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.707 41.4716C88.707 36.3952 88.5349 31.4048 88.6209 26.3284C88.707 23.0589 88.9651 23.9193 85.2653 23.5751C80.1029 23.0589 78.3821 32.6955 77.9519 36.8254C77.4356 42.5901 78.7262 48.6991 79.6727 54.3777C80.0168 56.3567 79.9308 60.4866 81.9958 61.4331C83.8026 62.2075 85.6955 60.2285 86.642 58.7658C88.793 55.3242 88.4488 50.1617 88.6209 46.2899C88.707 44.6551 88.707 43.0204 88.707 41.4716Z",
    fill: "url(#paint0_linear_7038_65057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4692 70.2089C84.2321 78.813 80.3603 81.2222 80.3603 81.2222L75.1118 82.2546C72.1003 81.9105 66.9379 80.6199 66.9379 80.6199C55.0643 76.5759 51.6226 75.4574 49.7297 70.9833C49.7297 70.7252 40.4373 38.4599 40.4373 38.4599C38.8886 21.854 56.2688 18.4124 58.9361 17.9822C61.5173 17.3799 78.1232 12.8197 82.9415 28.7373C82.9415 28.7373 90.1689 47.15 86.4692 70.2089Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6313 23.231C32.8666 25.9843 32.6945 31.1467 32.9526 36.9975C33.1247 41.5576 34.5874 45.4295 36.2222 49.8176C38.9755 57.3031 38.9755 57.3031 41.4706 61.6912C41.4706 61.6912 45.3425 67.628 50.2468 71.758C48.7841 66.0793 48.44 61.8633 47.1493 57.5612C45.6006 52.3128 46.0308 45.3434 48.3539 40.0089C48.3539 40.0089 49.6445 36.4812 55.0651 35.4488C60.4857 34.4163 55.0651 35.4488 55.0651 35.4488L38.6313 23.231Z",
    fill: "url(#paint1_linear_7038_65057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1817 56.3564C48.1817 56.3564 45.2563 49.9894 40.6101 53.7752C40.6101 53.7752 38.5451 55.41 41.1264 59.712C41.1264 59.712 44.9122 65.907 49.3863 62.4653L48.1817 56.3564Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6646 41.4717C47.6646 41.4717 47.6646 52.9151 49.8156 59.024L47.5786 59.4542C47.5786 59.4542 46.374 51.6245 42.3301 51.5385L47.6646 41.4717Z",
    fill: "url(#paint2_linear_7038_65057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5477 16.8638C110.133 35.7928 53.8619 35.6207 53.8619 35.6207C53.8619 35.6207 48.0111 38.374 38.6326 23.2309C38.6326 23.2309 36.1374 11.3572 62.7241 7.65746C62.7241 7.65746 80.2764 5.50644 91.5477 16.8638Z",
    fill: "url(#paint3_linear_7038_65057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3316 135.945H18.3262C18.3262 135.945 18.4122 130.266 18.4122 129.836C18.5843 124.243 18.9285 118.564 19.9609 113.058C21.4236 105.142 25.2094 98.1728 33.7275 96.1078C37.5993 95.1614 41.0409 97.5705 43.1059 100.668C43.0199 100.754 46.8917 105.486 42.3316 135.945Z",
    fill: "#DCDFFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7038_65057",
    x1: 77.8525,
    y1: 42.5526,
    x2: 88.7005,
    y2: 42.5526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7038_65057",
    x1: 58.8112,
    y1: 71.3285,
    x2: 34.4283,
    y2: 13.2113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7038_65057",
    x1: 55.9586,
    y1: 72.525,
    x2: 31.5756,
    y2: 14.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7038_65057",
    x1: 38.5974,
    y1: 21.6543,
    x2: 95.3273,
    y2: 21.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7038_65057"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.860352,
    width: 129.405,
    height: 135.084,
    rx: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.fa97cc6596ab31cc648bce94d91d43e8.svg";
export { ForwardRef as ReactComponent };